import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { CalAngularService } from '@cvx/cal-angular';
import { catchError, switchMap, throwError } from 'rxjs';
import { AppConfig } from '../services/app-config.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  // Static assets (e.g. assets/config.json) load before auth is ready — skip token.
  // Matches both relative ("assets/…") and absolute ("/assets/…") URLs.
  if (req.url.includes('assets/')) {
    return next(req);
  }

  const calService = inject(CalAngularService);
  const router = inject(Router);
  const scopes = AppConfig.settings?.apiScopes ?? [];

  // getAADToken runs MSAL acquireTokenSilent — auto-refreshes when near expiry.
  return calService.getAADToken(scopes).pipe(
    catchError((error) => {
      // Silent renewal failed (session truly expired) — send user to re-auth.
      void router.navigate(['/unauthorized']);
      // Surface as a 401 so callers/guards can tell auth failures apart from server errors.
      return throwError(
        () =>
          new HttpErrorResponse({ status: 401, statusText: 'Unauthorized', url: req.url, error }),
      );
    }),
    switchMap((token) => {
      const authReq =
        typeof token === 'string' && token
          ? req.clone({ setHeaders: { Authorization: `Bearer ${token}` } })
          : req;
      return next(authReq);
    }),
  );
};
